import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import N3rveLogo from './../../images/N3rveLogo.png'
import './Login.css'
import Cookies from 'universal-cookie';
import httpConfig from '../PostLogin/Dashboard/AxiosConfig/httpConfig';
import { login } from '../PostLogin/Dashboard/AxiosConfig/AxiosInstance';
import axios from 'axios';
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import { useJwt, decodeToken } from "react-jwt";
import CircularProgress from '@mui/material/CircularProgress';
import { logtoWix } from '../Helpers/LogToWix';

function Login() {
  const [email, onChangeEmail] = useState('')
  const [password, onChangePassword] = useState('');
  const [loginerror, setLoginError] = useState(false)
  const [passworderror, setPasswordError] = useState(false)
  const [emailerror, setEmailError] = useState(false)
  const [emailinvalid, setemailInvalidError] = useState(false)
  const [isChecked1, setIsChecked1] = useState(false);
  const cookies = new Cookies(null, { path: '/' });
  const { t, i18n } = useTranslation();
  const [showLoading, setShowLoading] = useState(false)

  const hasLogged = useRef(false);

  const navigate = useNavigate();
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  })



  const handleResize = () => {
    // console.log(window.innerWidth)
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  const handleSubmit = () => {
    setShowLoading(true);
    let emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;

    if (email.length == 0) {
      setEmailError(true)
    } else {
      // if (!emailRegex.test(email)) {
      //   // invalid email
      //    setEmailInvalidError(true)
      //   } else {
      //   // valid email
      //    setEmailInvalidError(false)
      // }   
      setEmailError(false)
    }

    if (password.length == 0) {
      setPasswordError(true)
    } else {
      setPasswordError(false)
    }

    if (emailerror !== true && passworderror !== true) {
      HandleLogin()
    } else {
      setShowLoading(false)
    }

  }

  useEffect(() => {
    cookies.set('artistname', "")
    window.addEventListener("resize", handleResize, false);

    if (!hasLogged.current) {
      if (cookies.get('token') !== undefined) {
        if (decodeToken(cookies.get('token')) !== null) {
          logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Login Page", { "desc": "User opened the login page" })
          hasLogged.current = true;
        } else {
          logtoWix("anonymous user", "pageview", "Login Page", { "desc": "User opened the login page" })
          hasLogged.current = true;
        }
      } else {
        logtoWix("anonymous user", "pageview", "Login Page", { "desc": "User opened the login page" })
        hasLogged.current = true;
      }
    }

  }, [])

  const openInNewTab = () => {
    const fromAccountPage = false;
    const fromLogin = true;


    // Store the state in localStorage or sessionStorage
    localStorage.setItem('dashboardProps', JSON.stringify({ fromAccountPage, fromLogin }));

    // Open /Dashboard in a new tab
    window.open("/Dashboard", "_blank");
  };


  const openLabelInNewTab = () => {
    const fromAccountPage = false;
    const fromLogin = true;


    // Store the state in localStorage or sessionStorage
    localStorage.setItem('dashboardProps', JSON.stringify({ fromAccountPage, fromLogin }));

    // Open /Dashboard in a new tab
    window.open("/dashboard/label", "_blank");
  };


  const HandleLogin = () => {
    //   const axiosInstance = axios.create({
    //     withCredentials: true
    //  })

    // login(email, password)
    //   .then((response)=>{
    //       console.log(response.status===200)
    //       if(response.status===200){
    //         navigate("/Dashboard", { state: { fromAccountPage: false}})
    //       }else{
    //         setLoginError(true)
    //       }
    //     }).catch(function (e){
    //       // console.log(e)
    //       setLoginError(true)
    //     });

    axios({
      method: 'post',
      url: "https://n3rve.fly.dev/auth/login",
      headers: {},
      data: {
        email: email,
        password: password
      }
    }).then(function (response) {
      console.log(response)

      if (response.status === 200) {
        const current = new Date();
        const nextYear = new Date();
        nextYear.setFullYear(current.getFullYear() + 1)

        if (isChecked1) {
          cookies.set('token', response.data.token, {
            path: '/',
            expires: nextYear
          });
        } else {
          cookies.set('token', response.data.token);
        }

        if (isChecked1) {
          cookies.set('artistname', "", {
            path: '/',
            expires: nextYear
          });
        } else {
          cookies.set('artistname', "");
        }

        if (isChecked1) {
          cookies.set('staysignedin', isChecked1, {
            path: '/',
            expires: nextYear
          });
        } else {
          cookies.set('staysignedin', isChecked1);
        }

        if (cookies.get("token") === null) {
          navigate("/mfa", { state: { email: email } })


          logtoWix(email, "auth", "Login Page", { "desc": "User directed to mfa" })



        } else {
          // navigate("/Dashboard", { state: { fromAccountPage: false,fromLogin:true}})
          navigate("/")

          logtoWix(email, "auth", "Login Page", { "desc": "Successful Login" })

          if (decodeToken(response.data.token).info.role === "artist" || decodeToken(response.data.token).info.role === "producer") {
            openInNewTab()
          }

          if (decodeToken(response.data.token).info.role === "label") {
            openLabelInNewTab()
          }

        }

        // navigate("/Dashboard", { state: { fromAccountPage: false}})
      } else {
        setLoginError(true)
        setShowLoading(false)
        logtoWix(email, "auth", "Login Page", { "desc": "Unsuccessful Login" })
      }
    }).catch(function (e) {
      console.log(e)
      setLoginError(true)
      setShowLoading(false)
      logtoWix(email, "auth", "Login Page", { "desc": "Unsuccessful Login" })
    });

    // navigate("/Dashboard", { state: { fromAccountPage: false }})
    // const requestOptions = {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ 
    //         accEmail: email,
    //         accPwd: password
    //     }),
    //     credentials:'include'
    // };
  }

  return (
    <div style={{ width: '100vw' }}>



      {/* ******************************************** */}


      {/* DESKTOP VIEW */}

      {
        dimensions.width >= 1024 &&
        <div className="LoginContainer">

          <div className='LoginContainerLeft' >
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo' />
            </Link>

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '11.25em' }}>
              <div className='WelcomeBackTxt'>{t('Welcomeback')}</div>
              <div className='PleaseEnterTxt'>{t('Pleaseenteryourdets')}</div>

              <div className='LoginHeader'>{t('Email')}</div>

              {
                !emailerror &&
                <input
                  value={email}
                  onChange={e => onChangeEmail(e.target.value)}
                  placeholder='Enter Email'
                  className='LoginInput'
                />

              }

              {
                emailerror &&
                <input
                  value={email}
                  onChange={e => onChangeEmail(e.target.value)}
                  placeholder='Enter Email'
                  className='LoginInput'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }


              {
                emailerror &&
                <div className='ErrorTxt'>Email cannot be empty</div>
              }


              <div className='LoginHeader'>{t('Password')}</div>

              {
                !passworderror &&
                <input
                  value={password}
                  onChange={e => onChangePassword(e.target.value)}
                  placeholder='Enter Password'
                  className='LoginInput'
                  type='password'
                />
              }

              {
                passworderror &&
                <input
                  value={password}
                  onChange={e => onChangePassword(e.target.value)}
                  placeholder='Enter Password'
                  className='LoginInput'
                  type='password'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }


              {
                passworderror &&
                <div className='ErrorTxt'>Password cannot be empty</div>
              }

              <Link to="/PasswordReset">
                <div className='ForgotPasswordTxt'>{t('Forgotpassword')}</div>
              </Link>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1em' }}>
                <div className='StaySignedInTxt'>Stay Signed In</div>
                <Checkbox checked={isChecked1} onChange={() => setIsChecked1(!isChecked1)}
                  iconStyle={{ fill: '#FFFFFF' }}
                  sx={{
                    [`&, &.${checkboxClasses.checked}`]: {
                      color: '#FFFFFF',
                    },
                    color: "#E91353",
                    '&.Mui-checked': {
                      color: "#E91353"
                    }
                  }}
                />
              </div>

              {
                loginerror &&
                <div className='ErrorTxt' style={{ marginTop: '1em' }}>Incorrect Email/Password</div>
              }


              {
                !showLoading &&
                <div onClick={() => handleSubmit()} className='LoginBtn' style={{ textDecoration: 'none', cursor: 'pointer' }}>
                  {t('Loginbtn')}
                  <div className="HoverOverlay" />
                </div>
              }

              {
                showLoading &&
                <div className='LoginBtn' style={{ textDecoration: 'none' }}>
                  <CircularProgress style={{ width: '2em', height: '2em', marginLeft: '0%' }} sx={{ color: '#FFFFFF' }} />
                </div>
              }

              {/* <div style={{maxWidth:'20.75em'}}>
               
                </div> */}

              <span className='DontHaveAccTxt'>{t('Donthaveacc')} <Link to="/Signup"><span className='DontHaveAccTxt' style={{ textDecoration: 'underline' }}>{t('Signuphere')}</span></Link></span>
            </div>
          </div>

          <div className='LoginContainerRight' style={{ backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/kaktv6iamo5qniikeclw")`, height: dimensions.height, width: '50%' }} />

        </div>
      }

      {/* /****************************************************************************** */}

      {/* /** TABLET VIEW */}
      {
        dimensions.width >= 768 && dimensions.width < 1024 &&
        <div className="LoginContainer" style={{ justifyContent: 'space-between' }}>

          <div className='LoginContainerLeft' >
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo' />
            </Link>

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '2.25em' }}>
              <div className='WelcomeBackTxt'>{t('Welcomeback')}</div>
              <div className='PleaseEnterTxt'>{t('Pleaseenteryourdets')}</div>

              <div className='LoginHeader'>{t('Email')}</div>

              {
                !emailerror &&
                <input
                  value={email}
                  onChange={e => onChangeEmail(e.target.value)}
                  placeholder='Enter Email'
                  className='LoginInput'
                />

              }

              {
                emailerror &&
                <input
                  value={email}
                  onChange={e => onChangeEmail(e.target.value)}
                  placeholder='Enter Email'
                  className='LoginInput'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }


              {
                emailerror &&
                <div className='ErrorTxt'>Email cannot be empty</div>
              }


              <div className='LoginHeader'>{t('Password')}</div>

              {
                !passworderror &&
                <input
                  value={password}
                  onChange={e => onChangePassword(e.target.value)}
                  placeholder='Enter Password'
                  className='LoginInput'
                  type='password'
                />
              }

              {
                passworderror &&
                <input
                  value={password}
                  onChange={e => onChangePassword(e.target.value)}
                  placeholder='Enter Password'
                  className='LoginInput'
                  type='password'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }


              {
                passworderror &&
                <div className='ErrorTxt'>Password cannot be empty</div>
              }

              <Link to="/PasswordReset">
                <div className='ForgotPasswordTxt'>{t('Forgotpassword')}</div>
              </Link>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1em' }}>
                <div className='StaySignedInTxt'>Stay Signed In</div>
                <Checkbox checked={isChecked1} onChange={() => setIsChecked1(!isChecked1)}
                  iconStyle={{ fill: '#FFFFFF' }}
                  sx={{
                    [`&, &.${checkboxClasses.checked}`]: {
                      color: '#FFFFFF',
                    },
                    color: "#E91353",
                    '&.Mui-checked': {
                      color: "#E91353"
                    }
                  }}
                />
              </div>

              {
                loginerror &&
                <div className='ErrorTxt' style={{ marginTop: '1em' }}>Incorrect Email/Password</div>
              }

              <div onClick={() => handleSubmit()} className='LoginBtn' style={{ textDecoration: 'none', cursor: 'pointer' }}>{t('Loginbtn')}</div>
              <span className='DontHaveAccTxt'>{t('Donthaveacc')} <Link to="/Signup"><span className='DontHaveAccTxt' style={{ textDecoration: 'underline' }}>{t('Signuphere')}</span></Link></span>
            </div>
          </div>

          <div className='LoginContainerRight' style={{ backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/kaktv6iamo5qniikeclw")`, height: dimensions.height, width: '30%' }} />

        </div>

      }


      {/* /****************************************************************************** */}

      {/* /** MOBILE VIEW */}
      {
        dimensions.width < 768 &&
        <div className="LoginContainer" style={{ height: '100vh' }}>


          <Link to="/" style={{ textDecoration: 'none' }}>
            <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo' />
          </Link>

          <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '2em' }}>
            <div className='WelcomeBackTxt'>{t('Welcomeback')}</div>
            <div className='PleaseEnterTxt'>{t('Pleaseenteryourdets')}</div>

            <div className='LoginHeader'>{t('Email')}</div>

            {
              !emailerror &&
              <input
                value={email}
                onChange={e => onChangeEmail(e.target.value)}
                placeholder='Enter Email'
                className='LoginInput'
              />

            }

            {
              emailerror &&
              <input
                value={email}
                onChange={e => onChangeEmail(e.target.value)}
                placeholder='Enter Email'
                className='LoginInput'
                style={{ border: '1px #FF6363 solid' }}
              />
            }


            {
              emailerror &&
              <div className='ErrorTxt'>Email cannot be empty</div>
            }


            <div className='LoginHeader'>{t('Password')}</div>

            {
              !passworderror &&
              <input
                value={password}
                onChange={e => onChangePassword(e.target.value)}
                placeholder='Enter Password'
                className='LoginInput'
                type='password'
              />
            }

            {
              passworderror &&
              <input
                value={password}
                onChange={e => onChangePassword(e.target.value)}
                placeholder='Enter Password'
                className='LoginInput'
                type='password'
                style={{ border: '1px #FF6363 solid' }}
              />
            }


            {
              passworderror &&
              <div className='ErrorTxt'>Password cannot be empty</div>
            }

            <Link to="/PasswordReset">
              <div className='ForgotPasswordTxt'>{t('Forgotpassword')}</div>
            </Link>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1em' }}>
              <div className='StaySignedInTxt'>Stay Signed In</div>
              <Checkbox checked={isChecked1} onChange={() => setIsChecked1(!isChecked1)}
                iconStyle={{ fill: '#FFFFFF' }}
                sx={{
                  [`&, &.${checkboxClasses.checked}`]: {
                    color: '#FFFFFF',
                  },
                  color: "#E91353",
                  '&.Mui-checked': {
                    color: "#E91353"
                  }
                }}
              />
            </div>

            {
              loginerror &&
              <div className='ErrorTxt' style={{ marginTop: '1em' }}>Incorrect Email/Password</div>
            }

            <div onClick={() => handleSubmit()} className='LoginBtn' style={{ textDecoration: 'none', cursor: 'pointer' }}>{t('Loginbtn')}</div>
            <span className='DontHaveAccTxt'>{t('Donthaveacc')} <Link to="/Signup"><span className='DontHaveAccTxt' style={{ textDecoration: 'underline' }}>{t('Signuphere')}</span></Link></span>
          </div>
        </div>




      }


    </div>
  );
}

export default Login;
